import { createBrowserRouter, RouterProvider, Outlet, Navigate } from "react-router-dom";
import { useContext } from 'react';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import Leftbar from './components/leftbar/Leftbar';
import Navbar from './components/navbar/Navbar';
import Rightbar from './components/rightbar/Rightbar';
import Rightbarprofile from './components/rightbarprofile/Rightbarprofile';
import UnlockModal from './components/unlockModal/UnlockModal';
import Login from './pages/login/Login';
import Register from './pages/register/Register';
import Home from './pages/home/Home';
import Profile from './pages/profile/Profile';    
import Chat from './pages/chat/Chat';
import PostDetail from './pages/postDetail/PostDetail';
import FriendList from './pages/friendList/FriendList';
import ForgotPassword from './pages/forgotPassword/ForgotPassword';
import ResetPassword from './pages/resetPassword/ResetPassword';
import Search from './pages/search/Search';
import Settings from './pages/settings/Settings';
import "./styles/styles.scss";

import { DarkModeContext } from './context/darkModeContext';
import { AuthContext } from './context/authContext';
import { SocketContextProvider } from './context/socketContext';
import { useWalletDatabase } from './lib/walletDatabase'; //Test
import { useEffect } from "react";

const queryClient = new QueryClient();

const ProtectedRoute = ({ children }) => {
  const { currentUser, privateKey } = useContext(AuthContext);

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  if (currentUser && !privateKey) {
    return (
      <>
        <UnlockModal />

        <div style={{ pointerEvents: 'none', userSelect: 'none' }}>
          {children}
        </div>
      </>
    );
  }

  return children;
};

const Layout = () => {
  const { darkMode } = useContext(DarkModeContext);
  return (
    <div className={`theme-${darkMode ? "dark" : "light"}`}>
      <Navbar />
      <div style={{display: "flex"}}>
        <Leftbar/>
        <div style={{flex: 6}}><Outlet/></div>
        <Rightbar/>
      </div>
    </div>
  );
};

const NavbarLayout = () => {
  const { darkMode } = useContext(DarkModeContext);
  return (
    <div className={`theme-${darkMode ? "dark" : "light"}`}>
      <Navbar />
      <Outlet/>
    </div>
  );
};

const NavLeftLayout = () => {
  const { darkMode } = useContext(DarkModeContext);
  return (
    <div className={`theme-${darkMode ? "dark" : "light"}`}>
      <Navbar />
      <div style={{ display: "flex" }}>
        <Leftbar />
        <div style={{ flex: 9 }}><Outlet /></div>
      </div>
    </div>
  );
};

const LayoutProfile = () => {
  const { darkMode } = useContext(DarkModeContext);
  return (
    <div className={`theme-${darkMode ? "dark" : "light"}`}>
      <Navbar />
      <div className="profile-layout">
        <Leftbar/>
        <div style={{flex: 6}}><Outlet/></div>
        <Rightbarprofile/>
      </div>
    </div>
  );
};

const router = createBrowserRouter([
  {
    path: "/",  
    element: (
      <ProtectedRoute>
        <Layout />
      </ProtectedRoute>
    ),
    children: [
      { path: "/", element: <Home /> },
      { path: "/post/:postId", element: <PostDetail/> },
    ],
  },
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <LayoutProfile />
      </ProtectedRoute>
    ),
    children: [
      { path: "/profile/:id", element: <Profile/> }
    ]
  },
  {
    path: "/chat",
    element: (
      <ProtectedRoute>
        <NavbarLayout />
      </ProtectedRoute>
    ),
    children: [
      { path: ":id", element: <Chat /> },
    ],
  },
  {
    path: "/postdetail",
    element: (
      <ProtectedRoute>
        <NavbarLayout />
      </ProtectedRoute>
    ),
  },
  {
    path: "/friendList",
    element: (
      <ProtectedRoute>
        <NavLeftLayout />
      </ProtectedRoute>
    ),
    children: [
      { path: ":id", element: <FriendList/> }
    ]
  },
  {
    path: "/search",
    element: (
      <ProtectedRoute>
        <NavLeftLayout /> 
      </ProtectedRoute>
    ),
    children: [
      { path: "", element: <Search /> }
    ]
  },
  {
    path: "/settings",
    element: (
      <ProtectedRoute>
        <NavLeftLayout/> 
      </ProtectedRoute>
    ),
    children: [
      { path: "", element: <Settings/> }
    ]
  },
  { path: "/login", element: <Login /> },
  { path: "/register", element: <Register /> },
  { path: "/forgot-password", element: <ForgotPassword /> },
  { path: "/reset-password", element: <ResetPassword /> },
]);

function App() {
  //Test
  const checkConnection = useWalletDatabase((state) => state.checkConnection); // <--- Lấy hàm checkConnection từ store

  useEffect(() => {
    // Gọi hàm kiểm tra kết nối ví khi App mount lần đầu tiên
    checkConnection();
  }, [checkConnection]);

  return (
    <QueryClientProvider client={queryClient}>
      <SocketContextProvider>
        <RouterProvider router={router} />
      </SocketContextProvider>
    </QueryClientProvider>
  );
}

export default App;